import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { DocumentDTO } from "../assistist/Document";

const PATH = "documents";

@Injectable({
  providedIn: "root",
})
export class DocumentHandlerService {
  constructor(private APIService: ApiService) {}

  /**
   * List/Search Documents with optional paging, sorting, filters, or count-only.
   */
  getDocuments(
    masterAccountID: number,
    integrationID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      sort?: string | string[];
      keyword?: string;
      filter_columns?: string[];
      category_search?: string;
      tag_search?: string;
      search_mode?: 'AND' | 'OR';
      forCount?: boolean;
    }
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}`, {
      params: queryParams,
    });
  }

  /**
   * Get a single Document by ID.
   */
  getDocument(
    masterAccountID: number,
    integrationID: number,
    documentID: number
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}/${documentID}`);
  }

  /**
   * Create a new Document.
   */
  postDocument(
    masterAccountID: number,
    integrationID: number,
    documentDTO: DocumentDTO
  ) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${integrationID}`, documentDTO);
  }

  /**
   * Generate mock booking data preview without persisting.
   */
  postGenerateMockBookingData(
    masterAccountID: number,
    integrationID: number,
    payload: {
      document_id?: number | null;
      name?: string | null;
      subtitle?: string | null;
      preview?: string | null;
      foreign_key?: string | null;
      booking_engine_integration_id?: number | null;
      prompt?: string | null;
      current_mock_data?: any;
    }
  ) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${integrationID}/generate-mock-booking-data`, payload);
  }

  /**
   * Clear persisted mock bookings for a document.
   */
  deleteMockBookings(
    masterAccountID: number,
    integrationID: number,
    documentID: number
  ) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${integrationID}/${documentID}/mock-bookings`);
  }

  /**
   * Update an existing Document.
   */
  putDocument(
    masterAccountID: number,
    integrationID: number,
    documentDTO: DocumentDTO
  ) {
    return this.APIService.put(`${PATH}/${masterAccountID}/${integrationID}/${documentDTO.id}`, documentDTO);
  }

  /**
   * Delete a Document by ID.
   */
  deleteDocument(
    masterAccountID: number,
    integrationID: number,
    documentID: number
  ) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${integrationID}/${documentID}`);
  }

  /**
   * Get categories and tags preview data.
   */
  getCategoriesTags(
    masterAccountID: number,
    integrationID: number
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}/categories-tags`);
  }
}
